/**
 * src/pages/LoginSecurity.tsx  （/account/security）
 * 「ログイン・セキュリティ」: 自分の追加認証の設定・状態（パスキー / メール認証 / 紛失時の案内）。
 * 管理者にだけ、「認証管理」（/account/security/admin）への入口を出す。
 * 追加認証の初期設定が必要な状態（mfa_setup）のときは、従来どおり /account の設定画面に誘導される。
 */

import { Link } from 'react-router-dom'
import { useAuth } from '../components/AuthGuard'
import { useIsMobile } from '../hooks/useIsMobile'
import SecuritySettings from '../components/mfa/SecuritySettings'

export default function LoginSecurity() {
  const { user, isAdmin } = useAuth()
  const isMobile = useIsMobile()

  return (
    <div style={{ maxWidth: 560 }}>
      <div style={{ marginBottom: 20 }}>
        <Link to="/account" style={{ fontSize: 12, color: 'var(--ink-3)', textDecoration: 'none' }}>‹ アカウント設定</Link>
        <h2 style={{ fontSize: isMobile ? 17 : 18, fontWeight: 700, margin: '6px 0 4px' }}>ログイン・セキュリティ</h2>
        <div style={{ fontSize: 12, color: 'var(--ink-3)' }}>
          {isAdmin ? '管理者アカウント' : 'アシスタントアカウント'}
          {user?.assistant_name && ` — ${user.assistant_name}`}
        </div>
      </div>

      <SecuritySettings isMobile={isMobile} forceSetup={false} />

      {isAdmin && (
        <div className="card" style={{ marginBottom: 20 }}>
          <div className="card-header"><span className="card-title">認証管理（管理者用）</span></div>
          <div style={{ padding: isMobile ? '16px 16px' : '20px 24px' }}>
            <div style={{ fontSize: 13, color: 'var(--ink-2)', lineHeight: 1.8, marginBottom: 12 }}>
              在籍中のアシスタントの認証状態の確認・リセット、追加認証の必須化、認証操作のログを確認できます。
            </div>
            <Link to="/account/security/admin" className="btn btn-outline"
              style={{ width: isMobile ? '100%' : undefined, boxSizing: 'border-box', textAlign: 'center', textDecoration: 'none' }}>
              認証管理を開く ›
            </Link>
          </div>
        </div>
      )}
    </div>
  )
}
